/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StaffRequestRecipient } from './StaffRequestRecipient';
import {
    StaffRequestRecipientFromJSON,
    StaffRequestRecipientFromJSONTyped,
    StaffRequestRecipientToJSON,
    StaffRequestRecipientToJSONTyped,
} from './StaffRequestRecipient';
import type { ReminderSettings } from './ReminderSettings';
import {
    ReminderSettingsFromJSON,
    ReminderSettingsFromJSONTyped,
    ReminderSettingsToJSON,
    ReminderSettingsToJSONTyped,
} from './ReminderSettings';

/**
 * 
 * @export
 * @interface RequestReminders
 */
export interface RequestReminders {
    /**
     * 
     */
    request_id: string;
    /**
     * 
     */
    title: string;
    /**
     * 
     */
    reminder_settings: ReminderSettings;
    /**
     * 
     */
    recipients: Array<StaffRequestRecipient>;
}

/**
 * Check if a given object implements the RequestReminders interface.
 */
export function instanceOfRequestReminders(value: object): value is RequestReminders {
    if (!('request_id' in value) || value['request_id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('reminder_settings' in value) || value['reminder_settings'] === undefined) return false;
    if (!('recipients' in value) || value['recipients'] === undefined) return false;
    return true;
}

export function RequestRemindersFromJSON(json: any): RequestReminders {
    return RequestRemindersFromJSONTyped(json, false);
}

export function RequestRemindersFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestReminders {
    if (json == null) {
        return json;
    }
    return {
        
        'request_id': json['request_id'],
        'title': json['title'],
        'reminder_settings': ReminderSettingsFromJSON(json['reminder_settings']),
        'recipients': ((json['recipients'] as Array<any>).map(StaffRequestRecipientFromJSON)),
    };
}

export function RequestRemindersToJSON(json: any): RequestReminders {
    return RequestRemindersToJSONTyped(json, false);
}

export function RequestRemindersToJSONTyped(value?: RequestReminders | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'request_id': value['request_id'],
        'title': value['title'],
        'reminder_settings': ReminderSettingsToJSON(value['reminder_settings']),
        'recipients': ((value['recipients'] as Array<any>).map(StaffRequestRecipientToJSON)),
    };
}

